import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ShieldLock } from 'assets/icons/ShieldLock.svg';

import SwitchWithDisabledFeatureTooltip from './SwitchWithDisabledFeatureTooltip';
import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

const PrivateRoomToggleField = () => {
  const { t } = useTranslation();
  const {
    isScheduling,
    roomForm: { control, watch, setValue },
  } = useCreateNewRoomDataContext();

  const isPrivateRoom = watch('isPrivateRoom');
  const isDisabled = isScheduling;
  const label = isScheduling ? t('only_one_feature_active') : undefined;

  return (
    <div className="flex gap-5">
      <ShieldLock className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5" />
      <div className="w-full flex flex-col gap-3">
        <div className="w-full flex justify-between items-center">
          <span className="text-size-sm text-black">{t('private_room')}</span>
          <Controller
            name="isPrivateRoom"
            control={control}
            render={({ field: { onChange, value } }) => (
              <SwitchWithDisabledFeatureTooltip
                checked={!!value}
                onChange={(newValue) => {
                  onChange(newValue);
                  setValue('isWaitingListEnabled', newValue, { shouldDirty: true });
                }}
                disabled={isDisabled}
                label={label}
              />
            )}
          />
        </div>
        {isPrivateRoom && (
          <div className="flex flex-col gap-4">
            <span className="text-sm font-light text-grayscale-black">{t('private_room_description')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivateRoomToggleField;
